import React from "react";
import { Markdown } from "./Markdown";
import ToolOutput, { isToolOutput } from "./ToolOutput";
import { GPTIcon } from "../GPTIcon";

export function MessageBubble({ message, gptIcon }) {
  const isUser = message.role === "user";
  // Detect dual-format tool replies (Store Copy Pack / Product Page Generator
  // etc.) and render them as proper Copy-card UI instead of raw markdown.
  const isTool = !isUser && isToolOutput(message.content);
  return (
    <div
      data-testid={`message-${message.role}`}
      className={[
        "flex gap-3 animate-bubble-in",
        isUser ? "justify-end" : "justify-start",
      ].join(" ")}
    >
      {!isUser && (
        <div className="shrink-0 h-9 w-9 rounded-xl bg-card border border-border/60 flex items-center justify-center text-foreground">
          <GPTIcon name={gptIcon} size={18} />
        </div>
      )}
      <div
        className={[
          // Tool replies need more horizontal room for their card stack.
          isTool ? "max-w-[95%] md:max-w-[88%]" : "max-w-[82%] md:max-w-[78%]",
          "px-5 py-3 text-[15px] leading-relaxed",
          isUser
            ? "bg-primary text-primary-foreground rounded-[20px] rounded-br-md"
            : "bg-card text-foreground border border-border/60 shadow-subtle rounded-[20px] rounded-bl-md",
        ].join(" ")}
      >
        {isUser ? (
          <div className="whitespace-pre-wrap break-words">{message.content}</div>
        ) : isTool ? (
          <ToolOutput reply={message.content} />
        ) : (
          <Markdown>{message.content}</Markdown>
        )}
      </div>
    </div>
  );
}

export function TypingBubble({ gptIcon }) {
  return (
    <div className="flex gap-3 animate-bubble-in" data-testid="typing-indicator">
      <div className="shrink-0 h-9 w-9 rounded-xl bg-card border border-border/60 flex items-center justify-center text-foreground">
        <GPTIcon name={gptIcon} size={18} />
      </div>
      <div className="bg-card border border-border/60 shadow-subtle rounded-[20px] rounded-bl-md px-5 py-4 flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-foreground/60 animate-typing-dot" />
        <span
          className="h-1.5 w-1.5 rounded-full bg-foreground/60 animate-typing-dot"
          style={{ animationDelay: "0.15s" }}
        />
        <span
          className="h-1.5 w-1.5 rounded-full bg-foreground/60 animate-typing-dot"
          style={{ animationDelay: "0.3s" }}
        />
      </div>
    </div>
  );
}
